<template>
  <Authenticated>
    <Confirm
      :open="showDeleteConfirm"
      message="Are you sure you want to delete this modifier set?"
      :subMsg="'By deleting this category you will delete all associated modifiers. This can not be undone'"
      :isDeleteConfirm="true"
      @confirm-modal="removeSet"
      @close="closeConfirmModal" />
    <ModifierModal :open="showModifierModal" :modifier="currentModifier" @commit="saveModifier" @remove="removeModifier" @closeModal="closeMod" />
    <div v-if="current" class="fab-container phone-buttons">
      <div :class="(optionsDisplay ? 'button-active' : '') + ' button iconbutton action-buttons '" @click="optionsDisplay = !optionsDisplay">
        <div>
          <font-awesome-icon icon="gear" :class="(optionsDisplay ? 'gear-icon-active' : '') + ' gear-icon'"></font-awesome-icon>
        </div>
      </div>
      <ul :class="(optionsDisplay ? 'options-disp' : '') + ' options'">
        <li class="bars-rule">
          <ToggleSwitch onLabel="Track Inv." offLabel="Track Inv." :modelValue="current.rules.inventory" modelName="inventory" @update:modelValue="updateInventory" />
        </li>
        <li class="bars-rule">
          <ToggleSwitch onLabel="Limit One" offLabel="Limit One" :modelValue="current.rules.oneonly" modelName="oneonly" @update:modelValue="updateOneOnly" />
        </li>
        <li class="bars-rule">
          <ToggleSwitch onLabel="Required" offLabel="Required" :modelValue="current.rules.required" modelName="required" @update:modelValue="updateRequired" />
        </li>
      </ul>
    </div>
    <div v-if="current">
      <div class="actions">
        <font-awesome-icon class="backwards" icon="backward" @click.stop.prevent="$router.go(-1)"></font-awesome-icon>
        <h2 class="title">{{ name }}</h2>
      </div>
      <div class="buttons" v-if="current.rules">
        <div class="desktop-buttons">
          <span class="option">
            <ToggleSwitch onLabel="Track Inv." offLabel="Track Inv." :modelValue="current.rules.inventory" modelName="inventory" @update:modelValue="updateInventory" />
          </span>
          <span class="option">
            <ToggleSwitch onLabel="Limit One" offLabel="Limit One" :modelValue="current.rules.oneonly" modelName="oneonly" @update:modelValue="updateOneOnly" />
          </span>
          <span class="option">
            <ToggleSwitch onLabel="Required" offLabel="Required" :modelValue="current.rules.required" modelName="required" @update:modelValue="updateRequired" />
          </span>
          <span class="option">
            <ToggleSwitch onLabel="Edit" offLabel="Re Order" :modelValue="reOrder" modelName="reOrder" @update:modelValue="updateReOrder" />
          </span>
          <button class="dark-btn" @click.stop.prevent="showOptionsModal = true">Apply to Categories</button>
          <button class="action-colour" @click="confirmDelete">Delete Modifier Set</button>
          <button
            class="action-colour"
            v-if="current.rules.inventory"
            @click="
              this.modifiers.forEach((mod) => {
                mod.quantity = 0;
              });
              this.save();
            ">
            Zero Out Quantity
          </button>
        </div>
      </div>

      <ul v-if="!reOrder" class="table wrapper" ref="history">
        <li v-bind:key="idx" v-for="(modifier, idx) in modifiers" class="modifierBox" @click.stop.prevent="showModifier(modifier)">
          <div class="box">
            <p style="text-align: center">
              <span class="modifier-name">{{ modifier.name }}</span>
              <span class="modifier-price" v-if="modifier.price"><CurrencyFormatter :value="modifier.price" :currency="currency" /></span>
              <span class="modifier-price" v-else>0.00</span>
              <span class="modifier-quantity" v-if="current.rules.inventory">
                <h3>{{ modifier.quantity }} units</h3>
              </span>
              <span class="quantity-input" v-if="current.rules.inventory" @click.stop.prevent="updateModifierQuantity(modifier)"
                >Quantity: <input class="text_input" type="text" v-model="modifier.quantity" @input="updateModifierQuantity(modifier)"
              /></span>
              <span v-if="current.rules.inventory" class="inventory-control" @click.stop.prevent="updateModifierQuantity(modifier)">
                <!-- <input
                  type="range"
                  v-model="modifier.quantity"
                  min="0"
                  max="100"
                  @change="updateModifierQuantity(modifier)"
                /> -->
              </span>
            </p>
          </div>
        </li>

        <li @click="addModifier" class="modifierBox newModifier">
          <div class="box">
            <p style="text-align: center">
              <span class="modifier-icon"><font-awesome-icon icon="plus" /></span>
              <span class="modifier-name">Add Modifier</span>
            </p>
          </div>
        </li>
      </ul>

      <div v-if="reOrder" class="table wrapper" ref="history">
        {{ orderedMods }}
        <draggable :list="this.modifiers" @start="drag = true" @end="checkMove" tag="ul" class="table layout wrapper content-gap" item-key="element">
          <template #item="{ element }">
            <li v-bind:key="element.id" class="modifierBox">
              <div class="box">
                <p style="text-align: center">
                  <span class="modifier-name">{{ element.name }}</span>
                  <span class="modifier-price" v-if="element.price"><CurrencyFormatter :value="element.price" :currency="currency" /></span>
                  <span class="modifier-price" v-else>0.00</span>
                </p>
              </div>
            </li>
          </template>
        </draggable>
      </div>
    </div>
    <div v-if="current">
      <h3>Products using Modifier</h3>
      <ul class="table wrapper" ref="history">
        <template v-for="product in modifierset_in_product.find((modprod) => modprod.mod == current._id).products" :key="product">
          <li v-if="productCat(product._id)" class="modifierBox">
            <router-link class="modifier-name" :to="`/products/${productCat(product._id).id.split(':')[1]}/${product._id.split(':')[1]}`"
              >{{ product.name }} <br />
              {{ productCat(product._id).id.split(":")[1] }}</router-link
            >
          </li>
        </template>
      </ul>
    </div>
    <ApplyModal :open="showOptionsModal" :categories="categories" :current="currentCatsInMod" @update="updateApplyAll" @close="showOptionsModal = false" />
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { Confirm, ModifierModal, ToggleSwitch, CurrencyFormatter, ApplyModal } from "@monolith/components";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import Slug from "slug";

export default {
  name: "ModifierSet",
  components: {
    Authenticated,
    Confirm,
    ToggleSwitch,
    ModifierModal,
    draggable,
    CurrencyFormatter,
    ApplyModal,
  },

  data() {
    return {
      currentSet: null,
      currentModifier: {},
      currentDrag: null,
      currentDragOverCategory: null,
      showDeleteConfirm: false,
      inventory: false,
      required: false,
      oneonly: false,
      loaded: false,
      showModifierModal: false,
      tableMode: true,
      optionsDisplay: false,
      reOrder: false,
      orderedMods: null,
      applyAll: false,
      showOptionsModal: false,
    };
  },

  methods: {
    closeMod() {
      this.showModifierModal = false;
      this.$router.go(-1);
    },

    closeConfirmModal() {
      this.showDeleteConfirm = false;
    },

    confirmDelete() {
      this.showDeleteConfirm = !this.showDeleteConfirm;
    },
    save() {
      this.channel.push("document:update", this.current);
    },
    updateApplyAll(value) {
      let categoriesToAdd = value.filter((cat) => !this.currentCatsInMod.includes(cat));
      let categoriesToRemove = this.currentCatsInMod.filter((cat) => !value.includes(cat));

      let productsToAdd = [];
      categoriesToAdd.forEach((cat) => {
        let category = this.categories.find((c) => c.id === cat);
        if (category) {
          category.value.products.forEach((prod) => {
            productsToAdd.push(prod);
          });
        }
      });

      productsToAdd.forEach((prod) => {
        let product = this.allProducts.find((p) => p.id.split(":")[1] === prod);
        if (product && !product.value.modifiersets.includes(this.current._id)) {
          product.value.modifiersets.push(this.current._id);
          this.channel.push("document:update", product.value);
        }
      });

      let productsToRemove = [];
      categoriesToRemove.forEach((cat) => {
        let category = this.categories.find((c) => c.id === cat);
        if (category) {
          category.value.products.forEach((prod) => {
            productsToRemove.push(prod);
          });
        }
      });

      productsToRemove.forEach((prod) => {
        let product = this.allProducts.find((p) => p.id.split(":")[1] === prod);
        if (product) {
          let index = product.value.modifiersets.indexOf(this.current._id);
          if (index > -1) {
            product.value.modifiersets.splice(index, 1);
            this.channel.push("document:update", product.value);
          }
        }
      });
    },
    updateInventory(value) {
      this.current.rules.inventory = value;
      this.save();
    },
    updateOneOnly(value) {
      this.current.rules.oneonly = value;
      this.save();
    },
    updateRequired(value) {
      this.current.rules.required = value;
      this.save();
    },
    updateReOrder(value) {
      this.reOrder = value;
    },
    showModifier(modifier) {
      this.currentModifier = modifier;
      this.showModifierModal = true;
      this.$router.push("/modifiers/" + this.$route.params.set + "/" + Slug(modifier.name));
    },
    addModifier() {
      this.$router.push("/modifiers/" + this.$route.params.set + "/" + "new-entry");
      this.currentModifier = { name: null, price: 0, quantity: 0, desc: "", active: true };
      this.showModifierModal = !this.showModifierModal;
    },
    saveModifier(modifier) {
      var foundMod = this.current.modifiers.find((mod) => modifier.name === mod.name);
      if (foundMod) {
        foundMod.name = modifier.name;
        foundMod.price = modifier.price;
        foundMod.quantity = modifier.quantity;
        foundMod.desc = modifier.desc;
        foundMod.active = modifier.active;
        this.save();
        this.closeMod();
      } else {
        this.current.modifiers.push(modifier);
        this.save();
        this.closeMod();
      }
    },
    updateModifierQuantity(modifier) {
      if (Number.isInteger(parseInt(modifier.quantity))) {
        this.channel.push("modifier:set:quantity", {
          modifierset: this.fullslug,
          modifier: modifier.name,
          quantity: modifier.quantity,
        });
      }
    },
    removeModifier(modifier) {
      var foundModIndex = this.current.modifiers.findIndex((mod) => modifier.name === mod.name);
      if (foundModIndex != -1) {
        this.current.modifiers.splice(foundModIndex, 1);
        this.save();
        this.closeMod();
      }
    },
    async removeSet() {
      /* step two remove it from modifier_sets */
      await this.channel.push("document:delete", {
        doc: this.current._id,
        rev: this.current._rev,
      });
      this.$router.push("/modifiers");
      this.$store.dispatch("getModifierSets");
    },
    async checkMove() {
      let modArray = [];
      this.modifiers.forEach((mod) => {
        modArray.push(mod);
      });
      this.current.modifiers = modArray;
      this.channel.push("document:update", this.current);
      this.$store.dispatch("getModifierSets");
    },
  },

  watch: {
    "current.rules.oneonly": {
      handler: function (newValue, oldValue) {
        if (oldValue != null && newValue != undefined) this.save();
      },
    },
    "current.rules.required": {
      handler: function (newValue, oldValue) {
        if (oldValue != null && newValue != undefined) this.save();
      },
    },
    "current.rules.inventory": {
      handler: function (newValue, oldValue) {
        if (oldValue != null && newValue != undefined) this.save();
      },
    },

    modifierset_in_product: {
      handler: function () {
        if (this.$route.params.set && this.$route.params.modifier) {
          let mod = this.current.modifiers.find((m) => Slug(m.name) === this.$route.params.modifier);
          if (mod) {
            this.showModifier(mod);
          }
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.$store.commit("currPage", "modifiers");
  },
  computed: {
    ...mapGetters({
      modifier_sets: "modifier_sets",
      allProducts: "allProducts",
      modifierset_in_product: "modifierset_in_product",
      productCat: "productCat",
      currency: "currency",
      categories: "categories",
    }),
    currentCatsInMod() {
      let cats = [];
      if (this.current) {
        this.modifierset_in_product.forEach((modprod) => {
          if (modprod.mod === this.current._id) {
            modprod.products.forEach((prod) => {
              let cat = this.productCat(prod._id);
              if (cat && !cats.includes(cat.id)) {
                cats.push(cat.id);
              }
            });
          }
        });
      }
      return cats;
    },

    getCategory(cat) {
      return this.productCat("category:" + cat);
    },
    slug() {
      return this.$route.params.set;
    },
    fullslug() {
      return "modifierset:" + this.$route.params.set;
    },
    name() {
      return this.$route.params.set.replace(/-/g, " ");
    },
    current() {
      let foundSet = this.modifier_sets.find((set) => set.id === "modifierset:" + this.slug);
      if (foundSet && "rules" in foundSet.value && Array.isArray(foundSet.value.rules)) {
        foundSet.value["rules"] = {
          inventory: false,
          oneonly: false,
          required: false,
        };
      }
      if (foundSet && !("rules" in foundSet.value)) {
        foundSet.value["rules"] = {
          inventory: false,
          oneonly: false,
          required: false,
        };
      }
      return foundSet ? foundSet.value : null;
    },
    modifiers() {
      return this.current ? this.current.modifiers : null;
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.actions {
  padding: 0 !important;
}

.desktop-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  .option {
    display: flex;
    align-items: center;
  }
  .dark-btn{border: none;
  }
}

.modifier-quantity {
  display: block;
}

.modifierBox {
  margin: 10px;
  a {
    text-decoration: none;
    color: var(--scondary-colour);
  }
}

.box {
  vertical-align: center;
}

.box p {
  flex: 0 1;
  min-width: 10rem;
  margin: 0px;
  h3 {
    margin-left: 0;
  }
  span {
    color: var(--secondary-txt-colour);
  }
}

.box .inventory-control {
  //transform: translate(0%, 250%);
  flex: 1 1;

  input[type="range"] {
    width: 100%;
    background-color: #ccc;
  }
}

.quantity-input {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.box .text_input {
  width: 50%;
  height: 2rem;
  font-size: 1.5rem;
  text-align: center;
}

.fab-container {
  position: fixed;
  bottom: 25px;
  right: 25px;
  cursor: pointer;
  z-index: 100;
}

.iconbutton {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  //box-shadow: 10px 10px 5px #aaaaaa;
}

.dark-btn {
  background: var(--secondary-colour);
  color: var(--action-colour);
}

.button {
  width: 60px;
  height: 60px;
  background: var(--secondary-colour);
  border: 0.25rem solid var(--banner-colour);
}

.button-active {
  background: var(--action-colour);
}

.iconbutton div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  color: white;
}

.options {
  display: none;
  list-style-type: none;
  position: absolute;
  bottom: 70px;
  right: 0;
}

.options li {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
}

.gear-icon {
  height: 1.5rem;
  color: var(--action-colour);
}

.gear-icon-active {
  color: var(--secondary-colour);
}

.options-disp {
  display: block;
}

@media only screen and (orientation: portrait) {
  .box .inventory-control {
    input[type="range"] {
      width: 80%;
    }
  }

  .button {
    border: 1px solid var(--secondary-text-colour) !important;
    margin-bottom: 1rem;
  }
  .options-disp {
    border: 1px solid var(--secondary-text-colour);
    border-radius: 5px;
    background-color: color-mix(in srgb, transparent, var(--secondary-colour) 80%); /* 80% of the color, 20% transparent */
    margin-bottom: 0;
    bottom: 60px;
    padding-inline-start: 0;
  }
}
</style>
